import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { classNames, i18n } from "@euroland/libs";
import { colorBlindModeSelector, enableColorBlindModeSelector, setColorBlind } from "../store/slice/settings";

function ColorBlindModeButton() {
  const colorBlindMode = useSelector(colorBlindModeSelector);
  const enableColorBlindMode = useSelector(enableColorBlindModeSelector);
  const dispatch = useDispatch();
  const handleChangeColorBlindMode = () => {
    dispatch(setColorBlind(!colorBlindMode));
  };

  if (!enableColorBlindMode) return null;

  return (
    <button
      className={classNames("blind-mode-area", { active: colorBlindMode })}
      onClick={handleChangeColorBlindMode}
      aria-pressed={colorBlindMode}
    >
      <span className="fs-icon fs-eye"></span>
      <span className="blind-mode-area__label">{i18n.translate("textEnableColorMode")}</span>
    </button>
  );
}

export default ColorBlindModeButton;
